/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { ActionLinkColumn, ColumnTexts, isPositiveNumber } from '@veeam-vspc/components';

import { VirtualInfrastructureDialog } from './components';

import type { VirtualInfrastructureDialogProps } from './components';

export interface VirtualInfrastructureColumnProps extends Omit<VirtualInfrastructureDialogProps, 'deactivate'> {
    value: string | number | null;
}

export const VirtualInfrastructureColumn: React.FC<VirtualInfrastructureColumnProps> = ({ value, onClose, ...restProps }) => (
    <ActionLinkColumn
        content={isPositiveNumber(value) ? value : ColumnTexts.DashSymbol}
        isLink={isPositiveNumber(value)}
        isExtMode={true}
        alignRight={true}
        renderPageDialog={({ onClose: onClosePageDialog }) => (
            <VirtualInfrastructureDialog
                {...restProps}
                onClose={(...args) => {
                    onClosePageDialog(...args);
                    onClose?.(...args);
                }}
            />
        )}
    />
);

